module.exports = __webpack_public_path__ + "static/media/soothing-music.db2da82e.ogg";